(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@wangeditor/editor"));
	else if(typeof define === 'function' && define.amd)
		define(["@wangeditor/editor"], factory);
	else if(typeof exports === 'object')
		exports["WangEditorPluginLinkCard"] = factory(require("@wangeditor/editor"));
	else
		root["WangEditorPluginLinkCard"] = factory(root["wangEditor"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__857__) {
return 